module.exports = __webpack_public_path__ + "static/1_1_defineai_EE-8cd1e07baa89f71e07517027275e124a.svg";